/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The template engine
 */
export const CreatePromptTemplateFormEngine = {
  Mustache: "mustache",
} as const;
/**
 * The template engine
 */
export type CreatePromptTemplateFormEngine = ClosedEnum<
  typeof CreatePromptTemplateFormEngine
>;

/**
 * The kind of prompt the template is used for
 */
export const CreatePromptTemplateFormKind = {
  Prompt: "prompt",
} as const;
/**
 * The kind of prompt the template is used for
 */
export type CreatePromptTemplateFormKind = ClosedEnum<
  typeof CreatePromptTemplateFormKind
>;

export type CreatePromptTemplateForm = {
  /**
   * The JSON Schema defining the placeholders found in the prompt template
   */
  arguments?: string | undefined;
  /**
   * The description of the prompt template
   */
  description?: string | undefined;
  /**
   * The template engine
   */
  engine: CreatePromptTemplateFormEngine;
  /**
   * The kind of prompt the template is used for
   */
  kind: CreatePromptTemplateFormKind;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  name: string;
  /**
   * The template content
   */
  prompt: string;
  /**
   * The suggested tool URNS associated with the prompt template
   */
  toolUrnsHint?: Array<string> | undefined;
  /**
   * The suggested tool names associated with the prompt template
   */
  toolsHint?: Array<string> | undefined;
};

/** @internal */
export const CreatePromptTemplateFormEngine$outboundSchema: z.ZodMiniEnum<
  typeof CreatePromptTemplateFormEngine
> = z.enum(CreatePromptTemplateFormEngine);

/** @internal */
export const CreatePromptTemplateFormKind$outboundSchema: z.ZodMiniEnum<
  typeof CreatePromptTemplateFormKind
> = z.enum(CreatePromptTemplateFormKind);

/** @internal */
export type CreatePromptTemplateForm$Outbound = {
  arguments?: string | undefined;
  description?: string | undefined;
  engine: string;
  kind: string;
  name: string;
  prompt: string;
  tool_urns_hint?: Array<string> | undefined;
  tools_hint?: Array<string> | undefined;
};

/** @internal */
export const CreatePromptTemplateForm$outboundSchema: z.ZodMiniType<
  CreatePromptTemplateForm$Outbound,
  CreatePromptTemplateForm
> = z.pipe(
  z.object({
    arguments: z.optional(z.string()),
    description: z.optional(z.string()),
    engine: CreatePromptTemplateFormEngine$outboundSchema,
    kind: CreatePromptTemplateFormKind$outboundSchema,
    name: z.string(),
    prompt: z.string(),
    toolUrnsHint: z.optional(z.array(z.string())),
    toolsHint: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolUrnsHint: "tool_urns_hint",
      toolsHint: "tools_hint",
    });
  }),
);

export function createPromptTemplateFormToJSON(
  createPromptTemplateForm: CreatePromptTemplateForm,
): string {
  return JSON.stringify(
    CreatePromptTemplateForm$outboundSchema.parse(createPromptTemplateForm),
  );
}
